<div class="file-upload-wrap">
    <div class="file-upload">
        <span class="file-upload-title" translate="core.addDocument">Dodajte dokument</span>
        <span class="addiko-icon icon-paperclip"></span>
    </div>
    <input ng-if="!tempHide" ng-model="vm.files" type="file" id="file-upload" 
            on-file-upload="vm.onFileUpload" class="opacity-0" />
</div>